import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/stores/:storeId/local-brands/create',
    name: 'localBrandManufacturerCreate',
    component: () =>
      import(
        '@/views/restricted/distributor-networks/store/tabs/LocalBrandManufacturerCreateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_STORE_UPDATE_PERMISSION'],
      menuSelected: 'networks'
    }
  },
  {
    path: '/manufacturers',
    name: 'manufacturers',
    component: () => import('@/views/restricted/manufacturers/ManufacturerLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_PRODUCT_READ_PERMISSION'],
      menuSelected: 'manufacturers'
    }
  },
  {
    path: '/manufacturers/create',
    name: 'manufacturerCreate',
    component: () =>
      import('@/views/restricted/manufacturers/manufacturer/ManufacturerCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_PRODUCT_CREATE_PERMISSION'],
      menuSelected: 'manufacturers'
    }
  },
  {
    path: '/manufacturers/:manufacturerId/edit',
    name: 'manufacturerUpdate',
    component: () =>
      import('@/views/restricted/manufacturers/manufacturer/ManufacturerUpdateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_PRODUCT_UPDATE_PERMISSION'],
      menuSelected: 'manufacturers'
    }
  },
  {
    path: '/manufacturers/:manufacturerId',
    name: 'manufacturerDetail',
    component: () =>
      import('@/views/restricted/manufacturers/manufacturer/ManufacturerDetailLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_PRODUCT_READ_PERMISSION'],
      menuSelected: 'manufacturers'
    }
  }
]
